import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';
import NavbarMenu from '@/components/navbar-menu';
import MobileMenu from '@/components/mobile-menu';

const Navigation = () => {
  const location = useLocation();
  const { language, t } = useLanguage();

  const navItems = [
    { path: '/', label: t('Начало', 'Home') },
    { path: '/collections', label: t('Колекции', 'Collections') },
    { path: '/packaging', label: t('Опаковки', 'Packaging') },
    { path: '/news', label: t('Новини', 'News') },
    { path: '/about', label: t('За нас', 'About') },
    { path: '/contact', label: t('Контакти', 'Contact') },
  ];

  const buildPath = (path: string) => {
    if (language !== 'en') {
      return path;
    }

    return path.includes('?') ? `${path}&lang=en` : `${path}?lang=en`;
  };

  const isActive = (path: string) => location.pathname === path;
  const isHome = location.pathname === '/';

  return (
    <nav className="z-50 w-full fixed inset-x-0 top-0 bg-transparent">
      <div className={`container mx-auto px-4 sm:px-6 lg:px-8 ${isHome ? 'pt-4 sm:pt-6 pb-3 sm:pb-4' : 'pt-4 sm:pt-6 py-3 sm:py-4 pb-3 sm:pb-4'}`}>
        {/* Desktop Layout: Logo Left | Navbar Center | Brand Logos Right */}
        <div className="nav-desktop hidden lg:flex items-center">
          {/* Left: Main Logo - fixed width for centering */}
          <div className="nav-logo-container w-48 xl:w-56 flex justify-start">
            <Link
              to={buildPath('/')}
              className="object-contain"
            >
              <img
                src={language === 'bg' ? '/Logo-BG.png' : '/Logo-EN.png'}
                alt={t('Лого Bonev Olives', 'Bonev Olives logo')}
                className="nav-logo h-16 xl:h-20 w-auto object-contain"
                width="224"
                height="80"
              />
            </Link>
          </div>

          {/* Center: Navigation Menu - takes remaining space and centers content */}
          <div className="flex-1 flex justify-center">
            <NavbarMenu navItems={navItems} buildPath={buildPath} isActive={isActive} />
          </div>

          {/* Right: Brand Logos - same width as left for true centering */}
          <div className="nav-brand-container w-48 xl:w-56 flex justify-end shrink-3 md:px-4">
            <img
              src="/brand-logos.png"
              alt={t('Партньорски логота', 'Partner logos')}
              className="nav-brand-logos h-12 xl:h-16 w-auto object-contain"
              width="224"
              height="64"
            />
          </div>
        </div>

        {/* Mobile/Tablet Layout: Logo Left | Brand Logos + Menu Button Right */}
        <div className="flex lg:hidden items-center justify-between gap-2 min-w-0">
          {/* Left: Main Logo */}
          <Link
            to={buildPath('/')}
            className="flex items-center flex-shrink min-w-0"
          >
            <img
              src={language === 'bg' ? '/Logo-BG.png' : '/Logo-EN.png'}
              alt={t('Лого Bonev Olives', 'Bonev Olives logo')}
              className="h-10 sm:h-12 w-auto max-w-[120px] sm:max-w-none object-contain"
              width="180"
              height="48"
            />
          </Link>

          {/* Right: Brand Logos + Menu Button */}
          <div className="flex items-center gap-3 sm:gap-4 flex-shrink-0">
            <img
              src="/brand-logos.png"
              alt={t('Партньорски логота', 'Partner logos')}
              className="h-7 sm:h-7 w-auto max-w-[140px] sm:max-w-[120px] object-contain"
              width="140"
              height="28"
              fetchPriority="high"
            />
            <MobileMenu navItems={navItems} buildPath={buildPath} />
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
